import React, { useState } from "react";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import Avatar from "@material-ui/core/Avatar";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";

import { makeStyles } from "@material-ui/styles";

import { useQueryWithStore, useAuthenticated } from "react-admin";
import { Loading } from "react-admin";

import {
  PersonalDetails,
  Address,
  MentorDetails,
  Availability,
} from "./ProfileTabs";

const useStyle = makeStyles({
  content: {
    marginTop: "10vh",
    paddingLeft: "5vw",
  },
  avatar: {
    width: 150,
    height: 150,
  },
  contentForm: {
    width: "90vw",
    height: "120vh",
  },
  button: {
    color: "#fff",
  },
  loader: {
    color: "#fff",
  },
});

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const a11yProps = (index) => {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
};

const ProfileDetails = ({ data, profileImage, props }) => {
  const uid = localStorage.getItem("user");
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <React.Fragment>
      <Tabs
        value={value}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
      >
        <Tab label="Personal Details" {...a11yProps(0)} />
        <Tab label="Address" {...a11yProps(0)} />
        {data.isMentor ? (
          <Tab label="Mentor Details" {...a11yProps(2)} />
        ) : null}
        {data.isMentor ? <Tab label="Availability" {...a11yProps(2)} /> : null}
      </Tabs>
      <TabPanel value={value} index={0}>
        <PersonalDetails data={data} uid={uid} profileImage={profileImage} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Address data={data} uid={uid} />
      </TabPanel>
      {data.isMentor ? (
        <TabPanel value={value} index={2}>
          <MentorDetails data={data} uid={uid} {...props} />
        </TabPanel>
      ) : null}
      {data.isMentor ? (
        <TabPanel value={value} index={3}>
          <Availability data={data} uid={uid} />
        </TabPanel>
      ) : null}
    </React.Fragment>
  );
};

export const MyProfile = (props) => {
  useAuthenticated();
  const classes = useStyle();
  const [image, setImage] = useState();
  const [isImageSet, setIsImage] = useState(false);

  const uid = localStorage.getItem("user");

  const { loaded, data } = useQueryWithStore({
    type: "getOne",
    resource: "User",
    payload: { id: uid },
  });
  const handleChangeImage = (event) => {
    setImage(URL.createObjectURL(event.target.files[0]));
    setIsImage(true);
  };
  return (
    <div>
      {loaded ? (
        <Grid container direction="row" spacing={2} className={classes.content}>
          <Grid item>
            <Grid
              container
              direction="row"
              alignItems="center"
              justify="flex-start"
              spacing={2}
            >
              <Grid item>
                {isImageSet ? (
                  <Avatar className={classes.avatar} src={image} />
                ) : (
                  <Avatar
                    className={classes.avatar}
                    src={data.profileImage ? data.profileImage._url : ""}
                  />
                )}
                <br />
                <input
                  accept="image/*"
                  style={{
                    display: "none",
                  }}
                  onChange={handleChangeImage}
                  id="upload-button-file"
                  multiple
                  type="file"
                />
                <label htmlFor="upload-button-file">
                  <Button variant="contained" component="span">
                    Upload Image
                  </Button>
                </label>
              </Grid>
              <Grid item>
                <Typography variant="h6">{data.email_}</Typography>
                {data.isMentor ? (
                  data.profileVerified ? (
                    <Typography variant="h6" style={{ color: "green" }}>
                      Profile Approved
                    </Typography>
                  ) : (
                    <Typography variant="h6" style={{ color: "#bbc918" }}>
                      Pending Approval{" "}
                    </Typography>
                  )
                ) : null}
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Paper elevation={2} className={classes.contentForm}>
              <ProfileDetails data={data} profileImage={image} props={props} />
            </Paper>
          </Grid>
        </Grid>
      ) : (
        <Loading className={classes.content} />
      )}
    </div>
  );
};
